export type PayType =
  | 'autoPayAcb'
  | 'autoPayNonAcb'
  | 'nonAutoPayAchToDeveloper'
  | 'nonAutoPayCheckToArcadia'
  | 'nonAutoPayCheckToDeveloper'
  | 'nonAutoPayInvoice';

type GetPayTypeParams = {
  collectAutomatically: boolean;
  includesBundledUtilityCharge: boolean;
  directPaymentToDeveloper: boolean;
  paysByCheck: boolean;
};

export const getPayType = ({
  collectAutomatically,
  includesBundledUtilityCharge,
  directPaymentToDeveloper,
  paysByCheck,
}: GetPayTypeParams): PayType => {
  if (!collectAutomatically) {
    if (paysByCheck) {
      if (directPaymentToDeveloper) {
        return 'nonAutoPayCheckToDeveloper';
      } else {
        return 'nonAutoPayCheckToArcadia';
      }
    } else if (directPaymentToDeveloper) {
      return 'nonAutoPayAchToDeveloper';
    } else {
      return 'nonAutoPayInvoice';
    }
  } else if (includesBundledUtilityCharge) {
    return 'autoPayAcb';
  } else {
    return 'autoPayNonAcb';
  }
};

export const getSingleProjectDetails = (
  lineItems: GetStatementPageDataQuery['statement']['lineItemsFormatted']
) => {
  const lineItem = lineItems.find(li => li.key === 'vnm_solar_charge');
  if (lineItem && 'vnmSolarProject' in lineItem && lineItem.vnmSolarProject) {
    const project = lineItem.vnmSolarProject;
    return {
      developer: project.developerName,
      projectName: `${project.developerName} ${project.name} solar project`,
      paymentAddress:
        project.paymentDetails?.paymentAddress?.replace(/\n/g, ', ') || '',
      paymentBankDetails: project.paymentDetails ?? undefined,
    };
  }

  return undefined;
};
